import React from 'react';
import type { Role } from '../../../services/queries/roleQueries';
import { summarizeRoles } from '../../../services/rbac/rolePermissionSummary';

interface RolePermissionPreviewProps {
  roles: Role[];
  title?: string;
}

export const RolePermissionPreview: React.FC<RolePermissionPreviewProps> = ({
  roles,
  title = 'Effective Permission Preview',
}) => {
  const summary = summarizeRoles(roles);
  const readCount = summary.permissions.filter((permission) => permission.read).length;
  const writeCount = summary.permissions.filter((permission) => permission.write).length;
  const deleteCount = summary.permissions.filter((permission) => permission.delete).length;

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-900/40">
      <div className="mb-3">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</h4>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {summary.roleNames.length > 0 ? summary.roleNames.join(', ') : 'No roles selected'}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 text-sm">
        <div>
          <div className="font-medium text-gray-700 dark:text-gray-200">Accessible apps</div>
          <div className="text-gray-600 dark:text-gray-300">
            {summary.accessibleApps.join(', ') || 'regal_main'}
          </div>
        </div>
        <div>
          <div className="font-medium text-gray-700 dark:text-gray-200">Primary role</div>
          <div className="text-gray-600 dark:text-gray-300">
            {summary.primaryRole?.name ?? 'None'}
          </div>
        </div>
        <div>
          <div className="font-medium text-gray-700 dark:text-gray-200">Object permissions</div>
          <div className="text-gray-600 dark:text-gray-300">
            Read {readCount} · Write {writeCount} · Delete {deleteCount}
          </div>
        </div>
        <div>
          <div className="font-medium text-gray-700 dark:text-gray-200">Edit scopes</div>
          <div className="text-gray-600 dark:text-gray-300">
            CS {String(summary.canEditCyberSweep)} · CB {String(summary.canEditCreditBlock)} · CM {String(summary.canEditCreditManagement)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RolePermissionPreview;
